export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./aviatrix.vue?vue&type=template&id=1f493010"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/aviatrix.vue?vue&type=template&id=1f493010
// module id = 9QPN
// module chunks = 0